// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1FO83","content":"GlobalSearch_content__2vhzw"};